import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { toast } from "sonner";
import { Sparkles, MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(formatError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6" data-testid="forgot-password-page">
      <Card className="w-full max-w-sm p-6">
        <div className="flex items-center gap-2 mb-6">
          <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary text-primary-foreground">
            <Sparkles className="h-4 w-4" />
          </div>
          <span className="font-display text-lg font-extrabold">OutlierPulse</span>
        </div>

        {sent ? (
          <div className="text-center py-4" data-testid="forgot-password-confirmation">
            <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-primary/10 text-primary">
              <MailCheck className="h-6 w-6" />
            </div>
            <h2 className="font-display text-xl font-bold">Demande reçue</h2>
            <p className="text-sm text-muted-foreground mt-2">
              Si un compte existe pour <span className="font-medium text-foreground">{email}</span> et que la livraison des e-mails est activée, un lien de réinitialisation valable 1 heure peut être envoyé. Cette réponse est identique dans tous les cas : elle ne confirme ni l’envoi ni la réception d’un e-mail.
            </p>
            <Link to="/login" className="mt-6 inline-block text-sm text-primary hover:underline font-medium" data-testid="back-to-login-link">
              Back to sign in
            </Link>
          </div>
        ) : (
          <>
            <h2 className="font-display text-2xl font-bold">Forgot password?</h2>
            <p className="text-sm text-muted-foreground mt-1">Saisissez votre e-mail. Un lien ne peut être envoyé que si la livraison des e-mails est activée sur cette installation.</p>
            <form onSubmit={submit} className="mt-6 space-y-4">
              <div className="space-y-1.5">
                <Label htmlFor="email">Email</Label>
                <Input
                  id="email"
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  data-testid="forgot-email-input"
                />
              </div>
              <Button type="submit" className="w-full" disabled={loading} data-testid="forgot-submit-button">
                {loading ? "Sending..." : "Send reset link"}
              </Button>
            </form>
            <div className="mt-4 text-sm text-muted-foreground text-center">
              Remembered it?{" "}
              <Link to="/login" className="text-primary hover:underline font-medium" data-testid="back-to-login-link">
                Sign in
              </Link>
            </div>
          </>
        )}
      </Card>
    </div>
  );
}
